// extracted by mini-css-extract-plugin
export var root = "about-module--root--6061d";
export var navContainer = "about-module--navContainer--d8791";
export var detailContainer = "about-module--detailContainer--9fd3e";
export var imageContainer = "about-module--imageContainer--42d10";
export var content = "about-module--content--a26cb";